import React, { useEffect } from 'react';
import './style.scss';
import Spin from 'antd/es/spin';
import { useDispatch, useSelector } from 'react-redux';
// import { Modal } from 'antd';
import { Modal } from 'react-bootstrap';

const ProgressTurn = () => {
  const loading = useSelector(state => state.progressReducer.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      if (loading > 0) {
        dispatch({ type: 'RESET_PROGRESS' });
      }
    }, 30000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <div className={`progress-loading ${loading > 0 ? "" : "hidden"}`}>
      <Spin size="large" />
    </div>
    // <Modal show={loading > 0} className="progress">
    //   <Spin size="large" />
    // </Modal>
    // <Modal className="modal-progress" visible={loading > 0} footer={null} closable={false} centered  zIndex={9999}>
    //   <Spin size="large" />
    // </Modal>
  )
}

export default React.memo(ProgressTurn);
